import { render, staticRenderFns } from "./closure_time.vue?vue&type=template&id=38e106f2&"
import script from "./closure_time.vue?vue&type=script&lang=ts&"
export * from "./closure_time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports